<template>
  <div dir="rtl" class="report-container" v-if="!loading">
    <div class="report-header">
      <div class="header-stats">
        <div>عدد الواجبات: <strong>{{ counts.homeworks }}</strong></div>
        <div>عدد الأنشطة: <strong>{{ counts.activities }}</strong></div>
        <div>عدد الاختبارات: <strong>{{ counts.exams }}</strong></div>
      </div>
      <div class="header-center">
        <h2 class="text-white">تقرير أداء الطلاب الشامل</h2>
        <p>تاريخ التقرير {{ reportDate }}</p>
      </div>
    </div>
    <div class="actions-bar no-print">
      <b-dropdown
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        text="📥 طباعة / تصدير"
        variant="primary"
      >
        <b-dropdown-item @click="printReport()">
          <i class="fa fa-print"></i>
          طباعة التقرير
        </b-dropdown-item>
        <hr>
        <b-dropdown-item @click="exportToExcel()">
          <i class="fa fa-download"></i>
          تصدير التقرير اكسل
        </b-dropdown-item>
      </b-dropdown>
      <button class="btn btn-success" :disabled="!rankedStudents.length" @click="openBoard()">
        🏆 عرض لوحة الأوائل
      </button>
    </div>
    <div v-if="showBoard" class="board-overlay no-print" @click.self="showBoard = false">
      <div ref="boardToolbar">
      <div class="board-toolbar">
        <span class="board-count-label">عدد الأوائل:</span>
        <button
          v-for="n in 10"
          :key="n"
          class="btn board-count-btn"
          :class="n === topCount ? 'btn-warning' : 'btn-outline-light'"
          :disabled="n > rankedStudents.length"
          @click="setTopCount(n)"
        >{{ n }}</button>
      </div>
      <div class="board-toolbar">
        <input
          v-model="schoolName"
          class="form-control board-school-input"
          placeholder="اسم المدرسة (اختياري)"
          @input="saveSchoolName()"
        >
        <button class="btn btn-success" :disabled="exporting" @click="downloadBoardImage()">
          <i class="fa fa-image"></i> تحميل صورة
        </button>
        <button class="btn btn-primary" :disabled="exporting" @click="printBoard()">
          <i class="fa fa-print"></i> طباعة / PDF
        </button>
        <button class="btn btn-light" @click="showBoard = false">
          <i class="fa fa-times"></i> إغلاق
        </button>
        <span v-if="exporting" class="board-exporting">جاري تجهيز الصورة...</span>
      </div>
      </div>
      <div class="board-stage" @click.self="showBoard = false">
        <div class="board-scaler" :style="{ width: boardWidth * boardScale + 'px', height: boardHeight * boardScale + 'px' }">
          <div class="board-inner" :style="{ transform: 'scale(' + boardScale + ')' }" v-html="boardHtml"></div>
        </div>
      </div>
    </div>
    <div class="col-12 table-responsive" id="reportTable">
      <table class="report-table">
        <thead>
          <tr>
            <th colspan="3" class="group-header">المجموع</th>
            <th colspan="3" class="group-header">الاختبارات</th>
            <th colspan="3" class="group-header">الأنشطة</th>
            <th colspan="3" class="group-header">الواجبات</th>
            <th rowspan="2" class="fixed-header">النسبة</th>
            <th rowspan="2" class="fixed-header student-name-header">اسم الطالب</th>
            <th rowspan="2" class="fixed-header">م</th>
          </tr>
          <tr>
            <th class="sub-header">الكل</th>
            <th class="sub-header">لم يتم الحل</th>
            <th class="sub-header">محلولة</th>
            <th class="sub-header">الكل</th>
            <th class="sub-header">لم يتم الحل</th>
            <th class="sub-header">محلولة</th>
            <th class="sub-header">الكل</th>
            <th class="sub-header">لم يتم الحل</th>
            <th class="sub-header">محلولة</th>
            <th class="sub-header">الكل</th>
            <th class="sub-header">لم يتم الحل</th>
            <th class="sub-header">محلولة</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(student, i) in students" :key="i">
            <td>{{ student.total.total }}</td>
            <td>{{ student.total.notCompleted }}</td>
            <td>{{ student.total.completed }}</td>
            <td>{{ student.exams.total }}</td>
            <td>{{ student.exams.notCompleted }}</td>
            <td>{{ student.exams.completed }}</td>
            <td>{{ student.activities.total }}</td>
            <td>{{ student.activities.notCompleted }}</td>
            <td>{{ student.activities.completed }}</td>
            <td>{{ student.homeworks.total }}</td>
            <td>{{ student.homeworks.notCompleted }}</td>
            <td>{{ student.homeworks.completed }}</td>
            <td :class="student.percentage === 0 ? 'td-danger' : 'td-success'">{{ student.percentage }}%</td>
            <td class="student-name">{{ student.name }}</td>
            <td>{{ i + 1 }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-else class="text-center p-5" dir="rtl">
    <div class="spinner-border text-primary" role="status"></div>
    <p class="mt-3">جاري تحميل التقرير...</p>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import {
  BOARD_WIDTH,
  BOARD_HEIGHT,
  buildBoardHtml,
  ensureBoardFont,
  boardToBlob,
} from "./top-students-board";
export default {
  components: {
    BDropdown,
    BDropdownItem,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: true,
      students: [],
      counts: { homeworks: 0, activities: 0, exams: 0 },
      reportDate: new Date().toISOString().split("T")[0],
      school_id: window.location.href.split("school_id=")[1]?.split("&")[0] || "",
      showBoard: false,
      exporting: false,
      boardScale: 1,
      boardWidth: BOARD_WIDTH,
      boardHeight: BOARD_HEIGHT,
      schoolName: "",
      topCount: 10,
    };
  },
  computed: {
    // الأعلى نسبة إنجاز، وعند التساوى الأكثر حلاً
    rankedStudents() {
      return this.students
        .filter((s) => s.percentage > 0)
        .slice()
        .sort((a, b) =>
          b.percentage - a.percentage ||
          ((b.total && b.total.completed) || 0) - ((a.total && a.total.completed) || 0)
        );
    },
    // أقصى عدد 10
    topStudents() {
      return this.rankedStudents.slice(0, Math.min(this.topCount, 10));
    },
    boardHtml() {
      return buildBoardHtml({
        students: this.topStudents,
        schoolName: this.schoolName,
        reportDate: this.reportDate,
      });
    },
  },
  mounted() {
    window.addEventListener("resize", this.fitBoard);
    window.addEventListener("keydown", this.onBoardKey);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.fitBoard);
    window.removeEventListener("keydown", this.onBoardKey);
  },
  created() {
    var g = this;
    setTimeout(() => {
      $("body").append(
        `<textarea class='get-local-storage' name='fullReportData'></textarea>`
      );
      var i = setInterval(() => {
        if ($(`.get-local-storage-value[name='fullReportData']`).length) {
          clearInterval(i);
          try {
            var raw = $(`.get-local-storage-value[name='fullReportData']`).val();
            var data = JSON.parse(raw);
            g.counts = data.counts || { homeworks: 0, activities: 0, exams: 0 };
            g.students = data.students || [];
          } catch (e) {
            g.students = [];
          }
          g.loading = false;
        }
      }, 10);
    }, 500);
  },
  methods: {
    openBoard() {
      try {
        this.schoolName = localStorage.getItem("top10_school_name_" + this.school_id) || this.schoolName;
        this.topCount = parseInt(localStorage.getItem("top10_count"), 10) || this.topCount;
      } catch (e) {}
      this.topCount = Math.max(1, Math.min(this.topCount, 10, this.rankedStudents.length));
      ensureBoardFont();
      this.showBoard = true;
      this.$nextTick(this.fitBoard);
    },
    setTopCount(n) {
      this.topCount = n;
      try {
        localStorage.setItem("top10_count", n);
      } catch (e) {}
    },
    saveSchoolName() {
      try {
        localStorage.setItem("top10_school_name_" + this.school_id, this.schoolName);
      } catch (e) {}
    },
    fitBoard() {
      var w = window.innerWidth - 32;
      var toolbar = this.$refs.boardToolbar;
      var h = window.innerHeight - (toolbar ? toolbar.offsetHeight : 110) - 28;
      this.boardScale = Math.max(0.3, Math.min(1, w / BOARD_WIDTH, h / BOARD_HEIGHT));
    },
    onBoardKey(e) {
      if (e.key === "Escape" && this.showBoard) this.showBoard = false;
    },
    async downloadBoardImage() {
      this.exporting = true;
      try {
        var blob = await boardToBlob(this.boardHtml, 2);
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = "لوحة-الأوائل-" + this.topStudents.length + "-" + this.reportDate + ".png";
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      } catch (e) {
        alert("تعذر إنشاء الصورة، جرّب الطباعة");
      }
      this.exporting = false;
    },
    async printBoard() {
      // نفتح النافذة فوراً قبل أى await عشان مانع النوافذ المنبثقة
      var win = window.open("", "_blank");
      if (!win) {
        alert("فضلاً اسمح بالنوافذ المنبثقة لهذا الموقع");
        return;
      }
      win.document.write('<p dir="rtl" style="font-family:Tahoma;text-align:center;margin-top:40vh">جاري تجهيز اللوحة...</p>');
      this.exporting = true;
      try {
        var blob = await boardToBlob(this.boardHtml, 2);
        var url = URL.createObjectURL(blob);
        win.document.open();
        win.document.write(
          `<!DOCTYPE html><html lang="ar" dir="rtl"><head><meta charset="UTF-8"><title>لوحة الأوائل ${this.topStudents.length} - ${this.reportDate}</title><style>
            @page { size: A4 portrait; margin: 0; }
            html, body { margin: 0; padding: 0; background: #fff; }
            img { display: block; width: 210mm; height: 296mm; object-fit: contain; margin: 0 auto; }
          </style></head><body><img src="${url}"></body></html>`
        );
        win.document.close();
        var img = win.document.querySelector("img");
        var doPrint = () => {
          win.focus();
          win.print();
        };
        if (img.complete) doPrint();
        else img.onload = doPrint;
        setTimeout(() => URL.revokeObjectURL(url), 120000);
      } catch (e) {
        win.close();
        alert("تعذر تجهيز اللوحة للطباعة");
      }
      this.exporting = false;
    },
    printReport() {
      var divToPrint = document.getElementById("reportTable");
      var headerHtml =
        `<div class="report-header">
          <div class="header-stats">
            <div>عدد الواجبات: <strong>${this.counts.homeworks}</strong></div>
            <div>عدد الأنشطة: <strong>${this.counts.activities}</strong></div>
            <div>عدد الاختبارات: <strong>${this.counts.exams}</strong></div>
          </div>
          <div class="header-center">
            <h2>تقرير أداء الطلاب الشامل</h2>
            <p>تاريخ التقرير: ${this.reportDate}</p>
          </div>
        </div>`;
      var tableHtml = divToPrint.outerHTML.replace('<table ', '<table dir="ltr" ');
      var newWin = window.open("");
      newWin.document.write(
        `<!DOCTYPE html><html lang="ar" dir="ltr"><head><meta charset="UTF-8"><style>
          * { box-sizing: border-box; margin: 0; padding: 0; }
          html, body { direction: ltr; font-family: 'Segoe UI', Tahoma, Arial, sans-serif; background: #fff; }
          .report-header {
            display: flex; justify-content: space-between; align-items: center;
            background: linear-gradient(135deg, #1a73a7, #2196f3);
            color: #fff; padding: 15px 25px; margin-bottom: 15px;
          }
          .header-center { text-align: center; flex: 1; }
          .header-center h2 { margin: 0 0 5px; font-size: 20px; }
          .header-center p { margin: 0; font-size: 13px; opacity: 0.9; }
          .header-stats { display: flex; flex-direction: column; gap: 3px; font-size: 12px; text-align: right; direction: rtl; }
          table { width: 100%; border-collapse: collapse; font-size: 12px; direction: ltr; }
          th, td { border: 1px solid #bbb; white-space: nowrap; text-align: center; vertical-align: middle; }
          th { color: #fff; padding: 6px 4px; }
          .group-header { background: #1a73a7; font-size: 13px; }
          .sub-header { background: #2196f3; font-size: 11px; }
          .fixed-header { background: #1a73a7; font-size: 13px; }
          td { padding: 5px 4px; font-size: 12px; }
          tbody tr:nth-child(even) { background-color: #f2f8ff; }
          .student-name { text-align: right !important; font-weight: bold; color: #1a73a7; direction: rtl; }
          .td-danger { color: #dc3545; font-weight: bold; }
          .td-success { color: #198754; font-weight: bold; }
          @page { size: landscape; margin: 10mm; }
          @media print {
            * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
          }
        </style></head><body dir="ltr">` +
        headerHtml +
        tableHtml +
        `</body></html>`
      );
      newWin.document.close();
      newWin.print();
    },
    exportToExcel() {
      var location = "data:application/vnd.ms-excel;base64,";
      var excelTemplate =
        '<html>' +
        "<head>" +
        '<meta http-equiv="content-type" content="text/plain; charset=UTF-8"/>' +
        "</head>" +
        '<body style="direction:rtl;text-align:right;">' +
        document.getElementById("reportTable").outerHTML +
        "</body>" +
        "</html>";
      window.location.href =
        location + btoa(unescape(encodeURIComponent(excelTemplate)));
    },
  },
};
</script>

<style scoped>
.report-container {
  padding: 15px;
  background: #fff;
  direction: rtl;
}
.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #1a73a7, #2196f3);
  color: #fff;
  padding: 15px 25px;
  margin-bottom: 15px;
}
.header-center {
  text-align: center;
  flex: 1;
}
.header-center h2 {
  margin: 0 0 5px;
  font-size: 20px;
}
.header-center p {
  margin: 0;
  font-size: 13px;
  opacity: 0.9;
}
.header-stats {
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: 12px;
}
.actions-bar {
  margin-bottom: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.board-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3000;
  background: rgba(6, 32, 35, 0.88);
  display: flex;
  flex-direction: column;
}
.board-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px 0;
}
.board-count-label {
  color: #fff;
  font-weight: bold;
  font-size: 15px;
}
.board-count-btn {
  width: 42px;
  height: 38px;
  padding: 0;
  font-weight: bold;
  font-size: 16px;
}
.board-school-input {
  width: 260px;
  max-width: 100%;
}
.board-exporting {
  color: #fff;
  font-weight: bold;
}
.board-stage {
  flex: 1;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 10px 16px 16px;
}
.board-scaler {
  position: relative;
  flex: none;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}
.board-inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 1000px;
  height: 1414px;
  transform-origin: top left;
}
.report-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.report-table thead th {
  text-align: center;
  vertical-align: middle;
  color: #fff;
  padding: 6px 4px;
  white-space: nowrap;
}
.group-header {
  background: #1a73a7;
  font-size: 13px;
}
.sub-header {
  background: #2196f3;
  font-size: 11px;
}
.fixed-header {
  background: #1a73a7;
  font-size: 13px;
}
.student-name-header {
  min-width: 160px;
}
.report-table thead th,
.report-table tbody td {
  border: 1px solid #bbb;
}
.report-table tbody td {
  text-align: center;
  vertical-align: middle;
  padding: 5px 4px;
  white-space: nowrap;
}
.report-table tbody tr:nth-child(even) {
  background-color: #f2f8ff;
}
.report-table tbody tr:hover {
  background-color: #e3f0ff;
}
.student-name {
  text-align: left !important;
  font-weight: bold;
  color: #1a73a7;
  min-width: 160px;
}
.td-danger {
  color: #dc3545 !important;
  font-weight: bold;
}
.td-success {
  color: #198754 !important;
  font-weight: bold;
}
#date2 {
  display: none;
}
@media print {
  .no-print {
    display: none !important;
  }
}
</style>
